module.exports = __webpack_public_path__ + "static/media/right-bg.90ed169a.png";